import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { ISDUIText } from "@faire/web-api--source/indigofair/data/ISDUIText";
import { ISlateTextStyle } from "@faire/web-api--source/indigofair/data/ISlateTextStyle";
import { Typography } from "@faire/web/slate/Typography";

export const mapSDUITextToSlateTypographyPropsArray = (
  sduiText: ISDUIText
): React.ComponentProps<typeof Typography>[] => {
  return sduiText.slate_text_segments.map(
    mapSDUITextSegmentToSlateTypographyProps
  );
};

const mapSDUITextSegmentToSlateTypographyProps = (
  sduiTextSegment: ISDUIText.ISDUITextSegment
): React.ComponentProps<typeof Typography> => {
  const { slate_text: { style, content } = {} } = sduiTextSegment;
  return {
    color: style?.color,
    variant: getSlateTypographyVariant(style?.type, style?.decorators),
    strikethrough: style?.decorators?.includes(
      ISlateTextStyle.TextDecorator.STRIKE_THROUGH
    ),
    style: style?.decorators?.includes(ISlateTextStyle.TextDecorator.UNDERLINE)
      ? { textDecoration: "underline" }
      : undefined,
    children: content ?? "",
  };
};
